import React, { Fragment } from "react";

import { OmIcon } from "@om/component-library-react";
import OmButton from "../forms/OmButton";
import "./SavingsPotCalculatorResults.scss";
import WarningMessage from "./WarningMessage";
import { showRecommendation } from "@om/redux/actions/savingsPotCalculator/savingsPotCalculatorForm";

const SavingsPotCalculatorResult = ({
  showResult,
  withdrawalGrossAmount,
  taxAmount,
  withdrawalNetAmount,
  withdrawalNetAmountRaw,
  withdrawalGrossAmountRaw,
  twoColumnImageLeftContent,
  tableContent,
  apiError,
}) => {
  return (
    <Fragment>
      {apiError && <h4>Oops, something went wrong, Please try again</h4>}
      {!apiError && showResult && (
        <div className="savings-pot-calculator-results-wrapper">
          <div className="container">
            <div className="first-section">
              <h6 className="heading restrict-mobile-width">
                RESULTS SUMMARY
                <span>
                  <slot name="more-info-button"></slot>
                </span>
              </h6>
              <div className="line"></div>

              {withdrawalGrossAmountRaw < 2000 && (
                <Fragment>
                  <div className="row">
                    <div className="sub-column">
                      <span className="no-top-margin m15 result-label">
                        Estimated Savings Pot value
                      </span>
                    </div>
                    <div className="sub-column text-right">
                      <span className="no-top-margin m15 result-label">
                        {withdrawalGrossAmount}
                      </span>
                    </div>
                  </div>

                  <div className="warning-withdrawal-amount">
                    <OmIcon slot="row-2-icon" iconName="error_outline" />
                    <div className="warning-error-fonts info-icon">
                      Unfortunately, you may not access your
                      <b> Savings Pot.</b> Based on your current investment
                      value, the withdrawal amount
                      <b> doesn't meet </b>the <b>minimum</b> of
                      <b> R2 000. </b>This could change based on the future
                      value of your investment.
                    </div>
                  </div>
                  <div className="line"></div>
                </Fragment>
              )}
              <div className="result-row restrict-mobile-width ">
                {withdrawalGrossAmountRaw >= 2000 && (
                  <Fragment>
                    <div className="row">
                      <div className="sub-column">
                        <span className="no-top-margin m15 result-label">
                          Estimated Savings Pot value
                        </span>
                      </div>
                      <div className="sub-column text-right">
                        <span className="no-top-margin m15 result-label">
                          {withdrawalGrossAmount}
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="sub-column">
                        <span className="no-bottom-margin no-top-margin result-label">
                          Estimated tax you will pay on withdrawal
                        </span>
                      </div>
                      <div className="sub-column text-right">
                        <span className="no-bottom-margin no-top-margin result-label">
                          -{taxAmount}
                        </span>
                      </div>
                    </div>
{/* 
                    <div slot="row-1-disclaimer ">
                      <p className="disclaimer result-label">
                        This is an estimate based on your input value which does
                        not include the fees deductions.
                      </p>
                    </div> */}
                    <div className="line"></div>
                  </Fragment>
                )}
              </div>
              <div className="result-row restrict-mobile-width">
                <OmIcon iconName="vector_flower" className="float-left" />

                <div className="float-right">
                  <p className="no-bottom-margin no-top-margin result-label">
                    Estimated amount you will receive <b>before fees</b>
                  </p>
                  <h5 className="no-bottom-margin no-top-margin">
                    <strong>{withdrawalNetAmount}</strong>
                  </h5>
                </div>
              </div>
              {withdrawalNetAmountRaw > 0 && (
                <div className="notification-msg-mobile">
                  <div className="line"></div>
                  <div
                    slot="warning-msg-slot"
                    className="warning-message-style warning-message-font"
                  >
                    <WarningMessage message="Please note that the tax is estimated, the correct tax amount is determined by SARS. Fees are determined based on your product. Actual fees and tax amounts are available on withdrawal. " />
                  </div>
                </div>
              )}
            </div>

            <div className="end-row">
              {withdrawalGrossAmountRaw >= 2000 && (
                <p
                  slot="end-heading"
                  className="tax-info-note-top result-label"
                >                  
                  Based on the information you've provided you may be able to
                  access your <strong>Savings Pot.</strong> You will have to pay
                  fees and taxes.
                </p>
              )}

              {withdrawalGrossAmountRaw < 2000 && (
                <p
                  slot="end-heading"
                  className="tax-info-note-top result-label"
                >                  
                  Based on the information you've provided you may not be able to
                  access your <strong>Savings Pot.</strong>
                </p>
              )}

              <p
                slot="end-heading"
                className="tax-info-note-bottom result-label"
              >
                Market fluctuations and future contributions between now and
                <strong> Sept 2024</strong> (the date when you can withdraw) can
                change your Savings Pot value.
              </p>

              <OmButton
                slot="end-button"
                type="primary"
                size="small"
                text="TELL ME MORE "
                withIcon
                iconName="chevron_down"
                onClick={() =>
                  window.open("/two-pot-retirement-system/", "_blank")
                }
              />
            </div>

            {withdrawalGrossAmountRaw > 0 && (
              <div className="notification-msg">
                <div
                  slot="warning-msg-slot"
                  className="warning-message-style warning-message-font"
                >
                  <WarningMessage message="Please note that the tax is estimated, the correct tax amount is determined by SARS. Fees are determined based on your product. Actual fees and tax amounts are available on withdrawal. " />
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="product-offering">
        <div slot="product-offering">
          {showRecommendation && (
            <TwoColumnImageLeft
              twoColumnImageLeftContent={twoColumnImageLeftContent}
            />
          )}
          {showRecommendation && <Table tableContent={tableContent} />}
        </div>
      </div>
    </Fragment>
  );
};

export default SavingsPotCalculatorResult;
